export const MAIN_CLASS_NAME = 'status-steps';
export const ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__item`;
export const LINE_CLASS_NAME = `${ITEM_CLASS_NAME}__line`;
export const BAR_CLASS_NAME = `${ITEM_CLASS_NAME}__bar`;
export const ICON_CLASS_NAME = `${ITEM_CLASS_NAME}__icon`;
export const TITLE_CLASS_NAME = `${ITEM_CLASS_NAME}__title`;
export const SUBTITLE_CLASS_NAME = `${ITEM_CLASS_NAME}__subtitle`;
export const DESCRIPTION_CLASS_NAME = `${ITEM_CLASS_NAME}__description`;
export const MODAL_CLASS_NAME = `${ITEM_CLASS_NAME}_modal`;
